import { useEffect, useRef, useCallback } from 'react';

const useIdleTimer = (onIdle, idleTime = 180000) => {
  const timeoutId = useRef(null);
  const isPaused = useRef(false);

  const resetTimer = useCallback(() => {
    if (timeoutId.current) {
      clearTimeout(timeoutId.current);
    }
    if (!isPaused.current) {
      timeoutId.current = setTimeout(onIdle, idleTime);
    }
  }, [onIdle, idleTime]);

  const pause = () => {
    isPaused.current = true;
    if (timeoutId.current) {
      clearTimeout(timeoutId.current);
    }
  };

  const resume = () => {
    isPaused.current = false;
    resetTimer();
  };

  useEffect(() => {
    // Events that denote user activity
    const events = [
      'mousemove',
      'mousedown',
      'keypress',
      'DOMMouseScroll',
      'mousewheel',
      'touchmove',
      'MSPointerMove',
      'scroll'
    ];

    const handleEvent = () => resetTimer();

    // Attach event listeners
    events.forEach(event => {
      window.addEventListener(event, handleEvent, { passive: true });
    });

    // Start timer on mount
    resetTimer();

    // Cleanup
    return () => {
      if (timeoutId.current) {
        clearTimeout(timeoutId.current);
      }
      events.forEach(event => {
        window.removeEventListener(event, handleEvent, { passive: true });
      });
    };
  }, [resetTimer]);

  return { pause, resume };
};

export default useIdleTimer;
